import { Dashboard } from "@mui/icons-material";
import { Robot } from "../components/RobotMap/models/Robot";
import { DashboardMode } from "./enums/Dashboard";

export enum RobotModel {
  SWIFTBOT = 'pudu_swiftbot',
  FLASHBOT = 'pudu_flashbot',
  FLASHBOT_MAX = 'pudu_flashbot_max',
  T300 = 'pudu_t300',
  CC1 = 'pudu_cc1',
  BELLABOT_PRO = 'pudu_bella',
  PUDUBOT2 = 'pudu_pudubot2',
}

export const ACCESS_TOKEN_KEY = 'accessToken';
export const WEBSOCKET_URL = process.env.REACT_APP_WEBSOCKET_URL;
export const BASE_API_URL = process.env.REACT_APP_SERVER_URL;
export const API_URL = BASE_API_URL + '/api/';
export const API_VERSION = 'v1';

export const PROFILE_KEY = 'profile'
export const isLocal = window.location.hostname.includes('localhost')
export const isDevMode = process.env.REACT_APP_DEV_MODE === 'true' || process.env.REACT_APP_DEV_MODE === '1';

export const DEFAULT_ICON_TYPE = process.env.REACT_APP_ICON_TYPE || '3D'; // Default icon type for robots, options are '2D' or '3D'
export const isShowIconTypeOptions = process.env.REACT_APP_ICON_TYPE_OPTIONS === 'true' || process.env.REACT_APP_ICON_TYPE_OPTIONS === '1';

export const NOTIFICATION_AUDIO_ID = 'notification-audio';
export const NEW_ROBOT_HERE_AUDIO_ID = 'new-robot-here-audio';

// Feature Flag
export const show3DFeature = process.env.REACT_APP_SHOW_3D_FEATURE === 'true' || process.env.REACT_APP_SHOW_3D_FEATURE === '1';
export const showConfigPage = process.env.REACT_APP_SHOW_CONFIG_PAGE === 'true' || process.env.REACT_APP_SHOW_CONFIG_PAGE === '1';
export const showRobotMapOnSelected = process.env.REACT_APP_SHOW_ROBOT_MAP_ON_SELECTED === 'true' || process.env.REACT_APP_SHOW_ROBOT_MAP_ON_SELECTED === '1';

export const DEFAULT_ROBOT_MODEL = process.env.REACT_APP_DEFAULT_ROBOT_MODEL || RobotModel.SWIFTBOT; // Default robot model if not specified
export const isDebugForceDefaultModel = false; // Force using default robot model for debugging purposesp

export const FIRE_ALARM_USE_ICON = process.env.REACT_APP_FIRE_ALARM_USE_ICON === 'true' || process.env.REACT_APP_FIRE_ALARM_USE_ICON === '1';
export const DYNAMIC_WIDGET_ENABLED = process.env.REACT_APP_DYNAMIC_WIDGET === 'true' || process.env.REACT_APP_DYNAMIC_WIDGET === '1';
export const CLEANING_MODE_ENABLED = process.env.REACT_APP_CLEANING_MODE === 'true' || process.env.REACT_APP_CLEANING_MODE === '1';

export const DEFAULT_TASK_MODE = DashboardMode.DELIVERY;
export const TASK_MODE_QUERY_PARAM = 't_mode';
export const CLEANING_DIALOG_QUERY_PARAM = 'isOpenCleaningBoard';
export const SELECTED_ZONE_QUERY_PARAM = 'selected_zones';
export const CLEANING_SUCCESS_DIALOG_QUERY_PARAM = 'cleaning_success_dialog';
export const SHOW_ZONE_QUERY_PARAM = 'show_zone_layers';

export const HIDE_DASHBOARD_CARD_KEY = "hideCard";
export const SHOW_EXPAND_SELECTED_ZONE = 'show_expand_selected_zone';
export const SHOW_EXPAND_UNSELECTED_ZONE = 'show_expand_unselected_zone';

export const MAP_FLYTO_LNG_QUERY_PARAM = 'map_flyto_lng';
export const MAP_FLYTO_LAT_QUERY_PARAM = 'map_flyto_lat';

export const JOB_TYPE = {
  DELIVERY: 'delivery',
  CLEANING: 'cleaning',
}
